export default "__VITE_ASSET__NtOChT8BTtF_L4NW9OXtJw__"